import PushpinIcon from "@/assets/images/PushpinIcon";
import { sidebarOnRailClass, sidebarRailBgClass } from "./sidebarChrome";

interface PinButtonProps {
  toggleSidebar?: () => void;
}

export default function PinButton({ toggleSidebar }: PinButtonProps) {
  return (
    <button
      onClick={toggleSidebar}
      aria-label="minimize_sidebar"
      className={`${sidebarRailBgClass} ${sidebarOnRailClass} rounded-full w-10 h-10 flex items-center justify-center`}
    >
      <PushpinIcon size={20} />
    </button>
  );
}
